import { Box, Stack, Typography } from "@mui/material"
import BCorp from "../../assets/logos/B-Corp-Logo-Black-RGB.png"
import ACI from "../../assets/logos/ACI_Code_Signatory_RGB.png"
import BlueHaloIcon from "../../assets/logos/TEM-BlueHalo-logo.png"
import "./style.css"
import { palette } from "../../theme"

const LeftSide = () => (
	<Stack spacing={2} alignItems="start">
		<div className="logos">
			<img src={BCorp} width="auto" height="50px" />
			<img src={ACI} width="auto" height="50px" />
		</div>
		<Typography variant="caption" color="skyBlue.mid">
			© {new Date().getFullYear()} Tasman Environmental. All Rights Reserved. 
		</Typography>
	</Stack>
)

const linkProps = {
	target: "_blank",
	rel: "noreferrer",
	style: {
		textDecoration: "none",
		color: palette.skyBlue.mid,
	},
}

const LeftRight = () => (
	<Stack spacing={1} alignItems="end">
		<a href="https://www.tasmanenvironmental.com.au/privacy/" {...linkProps}>
			<Typography variant="caption" color="black.main" sx={{ textDecoration: "underline" }} display="inline">
				Privacy policy
			</Typography>
		</a>
		<a href="https://www.tasmanenvironmental.com.au/website-terms/" {...linkProps}>
			<Typography variant="caption" color="black.main" sx={{ textDecoration: "underline" }} display="inline">
				Terms of service
			</Typography>
		</a>
		<img src={BlueHaloIcon} height="auto" width="250px" />
	</Stack>
)

const Footer = () => {
	const gridContainer = {
		display: "grid",
		gridTemplateColumns: "repeat(2, 1fr)",
		marginLeft: "auto",
	}

	const gridItem = {
		display: "flex",
		flexDirection: "column",
		padding: 1,
		mt: 3,
	}

	return (
		<Box data-testid="footer-parent" sx={gridContainer}>
			<Box sx={{ ml: 2, ...gridItem }}>
				<LeftSide />
			</Box>
			<Box sx={{ mr: 5, ...gridItem }}>
				<LeftRight />
			</Box>
		</Box>
	)
}

export default Footer
